import { getFieldDisplayValue } from '../../../utils/fieldDisplayValue';
import { bucketAggregationToFilter } from '../bucketAggregationToFilter';
import { getSelectedField } from '../getSelectedField';
export function getKeyedBucketFilterPayload(bucket, aggregation) {
    const { name } = bucket;
    const field = getSelectedField(aggregation);
    const formattedPrimaryName = getFieldDisplayValue(field, name);
    const filter = bucketAggregationToFilter(bucket, aggregation);
    return {
        id: formattedPrimaryName,
        field,
        filter,
    };
}
